import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SingleResultService {

    private offersUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingofferroom/bookingid/`;
    private inventoryUrl = `${environment.backendRoot}/webresources/frontend/entity.hoteloptionalextra/hotelExtras/inventory/`;
    private bookingOfferRoomUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingofferroom/`;
    private bookingOfferUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/`;
    private bookingOfferUrlSD = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/saveSD/`;
    private serviceDataUrl = `${environment.backendRoot}/webresources/frontend/entity.servicedata/`;
    private messageThreadUrl = `${environment.backendRoot}/webresources/frontend/entity.messagethread`;
    private bookingRequestUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/`;
    private assignmentUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/requestAssignedToUser/`;
    private confirmationEmailUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/sendBookingConfirmationEmail/`;

    constructor(private http: HttpClient) { }

    getOffer(offerId: number): Observable<any> {
        const url = this.offersUrl + offerId;
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    getActivePeriodOfOptionalFacilty(
        hotelId: number,
        roomTypeId: number,
        fromDate: string,
        toDate: string
    ): Observable<any> {
        const url = this.inventoryUrl + hotelId + '/' + roomTypeId +
            '/' + fromDate + '/' + toDate;
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    getRoomInfo(roomId: number): Observable<any> {
        const url = this.bookingOfferRoomUrl + roomId;
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    saveServiceData(serviceData): Observable<any> {
        const url = this.serviceDataUrl;
        const data = JSON.stringify(serviceData);
        return this.http.post(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    saveBookingOffer(offerId, bookingOffer): Observable<any> {
        const url = this.bookingOfferUrl + offerId;
        const data = JSON.stringify(bookingOffer);
        return this.http.put(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    saveBookingOfferSD(offerId, bookingOffer): Observable<any> {
        const url = this.bookingOfferUrlSD + offerId;
        const data = JSON.stringify(bookingOffer);
        return this.http.put(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    saveRoomOffer(roomId, roomOffer): Observable<any> {
        const url = this.bookingOfferRoomUrl + roomId;
        const data = JSON.stringify(roomOffer);
        return this.http.put(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    sendMessage(threadData) {
        const url = this.messageThreadUrl;
        const data = JSON.stringify(threadData);
        return this.http.post(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    initThread(threadData, threadId) {
        const url = this.messageThreadUrl + '/' + threadId;
        const data = JSON.stringify(threadData);
        return this.http.put(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    setBookingRequest(user, bookingRequestId) {
        const url = this.bookingRequestUrl + bookingRequestId;
        const data = JSON.stringify(user);
        return this.http.put(url, data,
            {headers: new HttpHeaders().set('Content-Type', 'application/json')}
        );
    }

    assignRequestToUser(bookingRequestId): Observable<any> {
        const url = this.assignmentUrl + bookingRequestId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    sendConfirmationEmail(offerId: number, email): Observable<any> {
        const url = this.confirmationEmailUrl + offerId + '/' + email + '?baseurl=' + environment.frontendRoot;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'text/plain') }
        );
    }

}
